import { useQueryClient } from '@tanstack/react-query';
import React from 'react'
import { FiLink } from 'react-icons/fi'
import { IoIosArrowForward } from 'react-icons/io'
import { Link } from 'react-router-dom'
import { updateTapCount } from '../../../helpers/tapCountMutation';

function WebsiteCls({ website, preview, Textcolor, Iconcolor, BtIColor }) {


    /* ------------------ tap count taking using tanstack query ----------------- */

    const queryClient = useQueryClient();

    const handleTap = (button, id) => {
        // console.log("iiii", id);

        updateTapCount(queryClient, button, id);
    };

    return (
        <div>
            {website?.map((webData) =>
                webData.websiteName ? (
                    <div className="flex justify-between items-center">
                        <Link
                            onClick={() => handleTap('website', webData._id)}
                            to={`${preview ? webData?.websiteUrl : ""}`}
                            target={`${preview ? "_blank" : ""}`}
                            className="mt-3"
                        >

                            <span className="w-12 h-12 rounded-full flex justify-center items-center" style={{ backgroundColor: `${Iconcolor ? Iconcolor : "black"}` }}>
                                <FiLink size={23} color={BtIColor ? BtIColor : 'white'} />

                            </span>
                            <h5 className=''
                                style={{
                                    color: `${Textcolor ? Textcolor : ""}`,
                                }}
                            >

                                {webData?.websiteName
                                    ? webData.websiteName
                                    : "Website Name"}
                            </h5>
                        </Link>
                        <IoIosArrowForward size={23} color={Textcolor ? Textcolor : 'black'} />
                    </div>
                ) : (
                    ""
                )
            )}
        </div>
    )
}

export default WebsiteCls